import React from 'react'
import { RepairAndInquiriesStatusEntity } from '../../../../customEntites/RepairAndInquiries.entity'
import { ServiceRequestItem } from '../../../../api/repairAndInquiries'

const pillBase: React.CSSProperties = {
  fontFamily: '"Red Hat Display", sans-serif',
  fontSize: '0.875rem',
  fontWeight: 500,
  lineHeight: '1.5',
  borderRadius: '999px',
  padding: '6px 14px',
  border: '1.5px solid #e0e0e0',
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  transition: 'all 0.15s',
  background: '#fff',
  color: '#616161',
}

const pillActive: React.CSSProperties = {
  ...pillBase,
  background: '#218cda',
  borderColor: '#218cda',
  color: '#fff',
}

const Badge = ({ count, active }: { count: number; active: boolean }) => (
  <span style={{
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '20px',
    height: '20px',
    padding: '0 6px',
    borderRadius: '999px',
    fontSize: '0.7rem',
    fontWeight: 700,
    background: active ? 'rgba(255,255,255,0.25)' : '#f0f0f0',
    color: active ? '#fff' : '#616161',
  }}>
    {count}
  </span>
)

export const FilterByStatus = ({
  activeStatus,
  setActiveStatus,
  statuses,
  requests,
}: {
  activeStatus: number,
  setActiveStatus: any,
  statuses: RepairAndInquiriesStatusEntity[],
  requests: ServiceRequestItem[],
}) => {
  const lang = localStorage.getItem('SELECTED_LNG')

  const countForStatus = (statusId: number) => {
    if (statusId === 0) return requests.length
    const status = statuses.find(s => s.id === statusId)
    if (!status) return 0
    return requests.filter(r => status.nameAims.includes(r.status)).length
  }

  return (
    <div className='filter-by-status-wrapper'>
      <div className='status-tabs-holder'>
        <button
          type='button'
          style={activeStatus === 0 ? pillActive : pillBase}
          onClick={() => setActiveStatus(0)}
        >
          {lang === 'EN' ? 'All' : 'Alle'}
          <Badge count={countForStatus(0)} active={activeStatus === 0} />
        </button>
        {statuses?.map((status) => {
          const isActive = activeStatus === status.id
          return (
            <button
              type='button'
              key={status.id}
              style={isActive ? pillActive : pillBase}
              onClick={() => setActiveStatus(status.id)}
            >
              {lang === 'EN' ? status.name : status.nameDe}
              <Badge count={countForStatus(status.id)} active={isActive} />
            </button>
          )
        })}
      </div>
    </div>
  )
}
